import coreDataForm from './coreData/coreDataForm';
import healthDataForm from './healthData/healthDataForm';
import oldSchoolDataForm from './schoolData/oldSchoolDataForm';
import schoolDataForm from './schoolData/schoolDataForm';
import oldChildCareDataForm from './childCareData/oldChildCareDataForm';
import childCareDataForm from './childCareData/childCareDataForm';
import childCareCostsDataForm from './childCareData/childCareCostsDataForm';
import newChildCareDataForm from './moveOutData/newChildCareDataForm';
import unsubscribeDataForm from './moveOutData/unsubscribeDataForm';
import changeOfAdressDataForm from './moveOutData/changeOfAdressDataForm';
import moveOutDataForm from './moveOutData/moveOutDataForm';
import type { Child } from '../../../common/types/child';
import type { TabForm } from '../../../common/types/form';
import type { DecryptedItem } from '../../../common/types/items';
import type { Client } from '../../../common/types/client';

const childForms = (clients: DecryptedItem<Client>[]): TabForm<Child>[] => {
  return [
    {
      key: 'childCoreDataForms',
      title: 'Stammdaten',
      forms: [coreDataForm(clients)],
    },
    {
      key: 'childHealthForm',
      title: 'Gesundheit',
      forms: [healthDataForm],
    },
    {
      key: 'childSchoolForm',
      title: 'Schule',
      forms: [oldSchoolDataForm, schoolDataForm],
    },
    {
      key: 'childCareForm',
      title: 'Kinderbetreuung',
      forms: [oldChildCareDataForm, childCareDataForm, childCareCostsDataForm],
    },
    {
      key: 'childDocuForm',
      title: 'Doku',
      forms: [],
    },
    {
      key: 'childMoveOutForm',
      title: 'Auszug',
      forms: [newChildCareDataForm, unsubscribeDataForm, changeOfAdressDataForm, moveOutDataForm],
    },
    {
      key: 'childTodosForm',
      title: 'ToDo',
      forms: [],
    },
    {
      key: 'childContactsForm',
      title: 'Kontakt',
      forms: [],
    },
  ];
};

export default childForms;
